// extracted by mini-css-extract-plugin
export default {"wrapper":"Image_wrapper__tyVVe","fadein":"Image_fadein__cyRg7"};